import genericAnnotationProperties from "./GenericAnnotationProperties";
export default genericAnnotationProperties({
  annotationType: "part",
  noColor: true,
  withTags: true,
  noType: true
});
